import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"



export const requestNotes = async ({ notesId, ticketId, verbose = false }) => {
    const formData = new FormData()
    formData.append("notes_id", notesId)
    formData.append("ticket_id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/fetch-notes", body: formData, verbose: verbose })
}